// @ts-nocheck
import { combineReducers } from '@reduxjs/toolkit';
import auth from '../slices/auth';
import accessOrders from '../slices/orders';
import organisationUsers from '../slices/users';
import products from '../slices/products';
import apiCalls from '../slices/apiCalls';

export default combineReducers({
    auth: auth.reducer,
    accessOrders: accessOrders.reducer,
    organisationUsers: organisationUsers.reducer,
    products: products.reducer,
    apiCalls: apiCalls.reducer,
});
